// extracted by mini-css-extract-plugin
export default {"siteContentWraper":"Mainlayout_siteContentWraper__5mGuS"};